// @owners { team: patients }
import { COLORS } from '@alto/design-library-tokens';

/**
 * Onboarding pages use a flat grey background under the FuzeRx brand, regardless of partnership,
 * Progyny status, or any landing-page-configured color (those were Alto-era affordances).
 */
export const onboardingBackgroundColor = () => COLORS.BACKGROUND_COLORS.GREY_LIGHTER;
